import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as n } from '../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { AccordionElementBase } from '../../lit-mixins/accordion-element-base/index.js';
import css_248z from '../accordion-item/styles/accordion-item.scss.js';
import css_248z$1 from './ops-step.scss.js';
import { renderAccordionItem } from '../accordion-item/layout/renderAccordionItem.js';

let OpsStep = class OpsStep extends AccordionElementBase(s) {
    render() {
        return this.renderAccordionElement(renderAccordionItem(this));
    }
};
OpsStep.styles = [css_248z, css_248z$1];
OpsStep = __decorate([
    n('ops-step')
], OpsStep);

export { OpsStep };
